import React from 'react'
import {ScheduleData} from './ScheduleDataSource'
import {Col, Row} from 'reactstrap';
import SelectInput from '../SelectInput/SelectInput'

class ScheduleSelect extends React.Component{

   constructor(props,context){
      super(props, context)      
    }
          
   render(){

    return (                       
    
        <div className="component-container">

          <p>תאום יום ושעה</p>
          <p>יש חלונות זמן קבועים עבור הגעת טכנאי</p>                 
            
          <Row>
            <Col ms={12}>
                  <SelectInput defaultText="בחר מועד" error={this.props.error} options={ScheduleData.options} dataKey="key" dataValue="date" id={this.props.id} name={this.props.name} onChange={this.props.onChange}  /> 
            </Col>       
          </Row>      
        </div>
    );
  }
}

export default ScheduleSelect;